export const BODY_ZONES = [
  {
    id: 'cou',
    label: 'Cou & Nuque',
    stretches: [
      {
        id: 'cou_1',
        name: 'Inclinaison latérale du cou',
        duration: '30s par côté',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/53d5df2a334b87f6e68026db5571d7eed76f6b7a11b40ff46e7706b00c7eb48f.png'
        ],
        steps: [
          "Assis ou debout, dos droit.",
          "Inclinez lentement l'oreille droite vers l'épaule droite.",
          "Placez doucement la main droite sur le côté gauche de la tête.",
          "Appliquez une légère pression sans forcer.",
          "Sentez l'étirement sur le côté gauche du cou.",
          "Maintenez 30 secondes puis changez de côté."
        ]
      },
      {
        id: 'cou_2',
        name: 'Rotation du cou',
        duration: '1 min',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/73783d6912318788320e7ece7a0974d8afc3bd0a386bcad023f0c33d13e7d3ff.png'
        ],
        steps: [
          "Assis ou debout, épaules détendues.",
          "Abaissez le menton vers la poitrine.",
          "Faites rouler lentement la tête vers la droite.",
          "Continuez le cercle vers l'arrière (doucement) puis vers la gauche.",
          "Effectuez 5 rotations dans chaque sens.",
          "Mouvement lent et contrôlé, jamais de douleur."
        ]
      },
      {
        id: 'cou_3',
        name: 'Étirement du trapèze',
        duration: '30s par côté',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/019e58f72b79ed02385771c7a7309d7b1899cc541dba52d87f5b7c376ae9119f.png'
        ],
        steps: [
          "Assis, attrapez le bord de la chaise avec la main droite.",
          "Inclinez la tête vers la gauche.",
          "Avec la main gauche, tirez doucement la tête vers le bas.",
          "Sentez l'étirement profond du trapèze droit.",
          "Respirez profondément et maintenez 30 secondes.",
          "Changez de côté."
        ]
      }
    ]
  },
  {
    id: 'epaules',
    label: 'Épaules',
    stretches: [
      {
        id: 'epaules_1',
        name: 'Étirement croisé du bras',
        duration: '30s par bras',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/a8474a34763484ae45d9e11c088e3a393acc2208c968287763009fa873a25c60.png'
        ],
        steps: [
          "Debout ou assis, dos droit.",
          "Amenez le bras droit tendu devant la poitrine.",
          "Avec la main gauche, tirez le coude droit vers vous.",
          "Gardez l'épaule basse, loin de l'oreille.",
          "Sentez l'étirement à l'arrière de l'épaule.",
          "Maintenez 30 secondes puis changez de bras."
        ]
      },
      {
        id: 'epaules_2',
        name: 'Ouverture des épaules au mur',
        duration: '30s par côté',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/6a47a00b7fd162e2ed57e0b7d365b0eeac72af90c6965a0fce36fbfa8b1a09a7.png'
        ],
        steps: [
          "Placez-vous perpendiculaire à un mur.",
          "Posez la paume droite sur le mur à hauteur d'épaule.",
          "Tournez lentement le corps vers la gauche.",
          "Sentez l'ouverture de l'épaule et du pectoral.",
          "Ne forcez pas, allez-y progressivement.",
          "Maintenez 30 secondes puis changez de côté."
        ]
      },
      {
        id: 'epaules_3',
        name: 'Mains dans le dos',
        duration: '30s',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/4c369e2e51c1945dddb21228db8570202eb07dd48e998cac1caebf9f1b447d6a.png'
        ],
        steps: [
          "Debout, amenez les deux mains derrière le dos.",
          "Entrelacez les doigts, paumes l'une contre l'autre.",
          "Tendez les bras et éloignez les mains des fesses.",
          "Ouvrez la poitrine en rapprochant les omoplates.",
          "Levez légèrement les mains pour intensifier.",
          "Maintenez 30 secondes en respirant profondément."
        ]
      }
    ]
  },
  {
    id: 'dos',
    label: 'Dos',
    stretches: [
      {
        id: 'dos_1',
        name: 'Chat-Vache',
        duration: '1-2 min',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/ac0d3512e5e2df4aee7464d44e1fe111322654aac9ed7c194e81a6cecb01193f.png'
        ],
        steps: [
          "Mettez-vous à quatre pattes, mains sous les épaules.",
          "Inspirez : creusez le dos, levez la tête (Vache).",
          "Expirez : arrondissez le dos, rentrez le menton (Chat).",
          "Alternez lentement entre les deux positions.",
          "Synchronisez le mouvement avec votre respiration.",
          "Répétez 10 à 15 fois."
        ]
      },
      {
        id: 'dos_2',
        name: 'Torsion allongée',
        duration: '1 min par côté',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/68068aa2b6593da8ee20f8b483a7767b1c390ab647a2160215f80677c4b57fc9.png'
        ],
        steps: [
          "Allongé sur le dos, bras en croix.",
          "Pliez les genoux et amenez-les vers la poitrine.",
          "Laissez les genoux tomber vers la droite.",
          "Tournez la tête vers la gauche.",
          "Gardez les deux épaules au sol.",
          "Maintenez 1 minute puis changez de côté."
        ]
      },
      {
        id: 'dos_3',
        name: 'Étirement lombaire genoux-poitrine',
        duration: '30s-1 min',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/8fc7797efe2c4e2a9bf081e3361290b235634fc681d5e921526be56e4d44dfb1.png'
        ],
        steps: [
          "Allongé sur le dos, jambes tendues.",
          "Amenez les deux genoux vers la poitrine.",
          "Enlacez vos genoux avec vos bras.",
          "Tirez doucement les genoux vers vous.",
          "Balancez légèrement de gauche à droite pour masser le bas du dos.",
          "Maintenez 30 secondes à 1 minute."
        ]
      }
    ]
  },
  {
    id: 'bras',
    label: 'Bras & Poignets',
    stretches: [
      {
        id: 'bras_1',
        name: 'Étirement du biceps au mur',
        duration: '30s par bras',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/f2d99bbaae22a0cc8905c45046f6aed86759b5a56ab19baff06490e7f79b0c4e.png'
        ],
        steps: [
          "Face à un mur, placez la paume droite contre le mur à hauteur d'épaule.",
          "Doigts pointés vers l'arrière (vers le bas).",
          "Tournez lentement le corps vers la gauche.",
          "Sentez l'étirement dans le biceps et l'avant-bras.",
          "Gardez le bras tendu sans verrouiller le coude.",
          "Maintenez 30 secondes puis changez de bras."
        ]
      },
      {
        id: 'bras_2',
        name: 'Étirement du triceps',
        duration: '30s par bras',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/616c09e676ec1357cfb11e0e1577bba53fa937b7a76537925e787ec1cda65ba0.png'
        ],
        steps: [
          "Levez le bras droit au-dessus de la tête.",
          "Pliez le coude pour que la main touche le haut du dos.",
          "Avec la main gauche, poussez doucement le coude droit vers l'arrière.",
          "Gardez la tête droite, ne la poussez pas en avant.",
          "Sentez l'étirement à l'arrière du bras.",
          "Maintenez 30 secondes puis changez de bras."
        ]
      },
      {
        id: 'bras_3',
        name: 'Extension des poignets',
        duration: '20s par main',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/fb667e1ef3a2c90d29d78836ac408c8adad3b1fde128c37974f61c98ffe401a8.png'
        ],
        steps: [
          "Tendez le bras droit devant vous, paume vers le haut.",
          "Avec la main gauche, tirez les doigts droits vers le bas.",
          "Sentez l'étirement dans l'avant-bras.",
          "Puis retournez la paume vers le bas et tirez les doigts vers vous.",
          "Maintenez chaque position 20 secondes.",
          "Changez de main."
        ]
      }
    ]
  },
  {
    id: 'poitrine',
    label: 'Poitrine & Abdos',
    stretches: [
      {
        id: 'poitrine_1',
        name: 'Ouverture de la poitrine en porte',
        duration: '30s',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/d74c9cf9e323bd7acd3b9b5eae52f08b52e9cbf20b392e9b703fb226ca701c9e.png'
        ],
        steps: [
          "Placez-vous dans l'encadrement d'une porte.",
          "Posez les avant-bras de chaque côté du cadre, coudes à 90 degrés.",
          "Faites un petit pas en avant.",
          "Laissez la poitrine s'ouvrir vers l'avant.",
          "Gardez le dos droit, ne cambrez pas excessivement.",
          "Maintenez 30 secondes en respirant profondément."
        ]
      },
      {
        id: 'poitrine_2',
        name: 'Étirement du cobra au sol',
        duration: '20-30s',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/b7c917650468324c3c270e71d7f6a7624a31b64f1a1441597f483efa1c3f0e59.png'
        ],
        steps: [
          "Allongé sur le ventre, mains sous les épaules.",
          "Poussez doucement le buste vers le haut.",
          "Gardez les hanches au sol.",
          "Ouvrez la poitrine et regardez légèrement vers le haut.",
          "Contractez légèrement les fessiers pour protéger le bas du dos.",
          "Maintenez 20 à 30 secondes."
        ]
      },
      {
        id: 'poitrine_3',
        name: 'Étirement abdominal debout',
        duration: '20s par côté',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/82e510a24f6887de3bfc8bae893807896e8f29a8bf0765cf558735875b167ec6.png'
        ],
        steps: [
          "Debout, pieds écartés largeur de hanches.",
          "Levez les deux bras au-dessus de la tête, mains jointes.",
          "Inclinez-vous lentement vers la droite.",
          "Sentez l'étirement sur tout le flanc gauche.",
          "Gardez les hanches stables, ne les poussez pas.",
          "Maintenez 20 secondes puis changez de côté."
        ]
      }
    ]
  },
  {
    id: 'hanches',
    label: 'Hanches & Fessiers',
    stretches: [
      {
        id: 'hanches_1',
        name: 'Pigeon allongé',
        duration: '1 min par côté',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/0805a17e15009110300701ed0e47d1fe0b840993bf2e8283b6579fdf0aa14c2e.png'
        ],
        steps: [
          "Depuis quatre pattes, amenez le genou droit vers la main droite.",
          "Allongez la jambe gauche derrière vous.",
          "Le tibia droit est en diagonale devant vous.",
          "Abaissez les hanches vers le sol.",
          "Penchez-vous en avant sur les avant-bras pour intensifier.",
          "Maintenez 1 minute puis changez de côté."
        ]
      },
      {
        id: 'hanches_2',
        name: 'Fente basse du psoas',
        duration: '30s par côté',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/734236bbe38a37e7bdc30046655edc3893101af05a9bcb25a6fb75e7c2e5c0d9.png'
        ],
        steps: [
          "Un genou au sol, l'autre pied en avant à 90 degrés.",
          "Poussez doucement les hanches vers l'avant.",
          "Gardez le buste droit et les abdos engagés.",
          "Sentez l'étirement profond à l'avant de la hanche arrière.",
          "Levez les bras pour intensifier l'étirement.",
          "Maintenez 30 secondes puis changez de côté."
        ]
      },
      {
        id: 'hanches_3',
        name: 'Figure 4 allongé',
        duration: '30s par côté',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/8d1d1e88d8db9d3898144e37d3837ed03f23ab8fa3fc543e83c70b38ef23c599.png'
        ],
        steps: [
          "Allongé sur le dos, pieds au sol.",
          "Placez la cheville droite sur le genou gauche.",
          "Attrapez l'arrière de la cuisse gauche avec les deux mains.",
          "Tirez la cuisse vers vous.",
          "Sentez l'étirement dans le fessier droit.",
          "Maintenez 30 secondes puis changez de côté."
        ]
      }
    ]
  },
  {
    id: 'cuisses',
    label: 'Cuisses',
    stretches: [
      {
        id: 'cuisses_1',
        name: 'Étirement du quadriceps debout',
        duration: '30s par jambe',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/fb682d54230204a81559dbc2aa37fb8591a522951aa3a54b0c6743e02cebe0ae.png'
        ],
        steps: [
          "Debout, appuyez-vous sur un mur si nécessaire.",
          "Pliez le genou droit et attrapez le pied avec la main droite.",
          "Tirez le talon vers la fesse.",
          "Gardez les genoux collés l'un à l'autre.",
          "Contractez les abdos pour éviter de cambrer le dos.",
          "Maintenez 30 secondes puis changez de jambe."
        ]
      },
      {
        id: 'cuisses_2',
        name: 'Étirement des ischio-jambiers',
        duration: '30s par jambe',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/ffe50381cbdd884415806f9ed87fbf9fdbd7dfcc1597dee4a5235d2cebdc06e1.png'
        ],
        steps: [
          "Debout, posez le talon droit sur une surface basse (marche, tabouret).",
          "Gardez la jambe tendue sans verrouiller le genou.",
          "Penchez le buste vers l'avant en gardant le dos droit.",
          "Sentez l'étirement à l'arrière de la cuisse.",
          "Ne forcez pas, allez-y progressivement.",
          "Maintenez 30 secondes puis changez de jambe."
        ]
      },
      {
        id: 'cuisses_3',
        name: "Étirement de l'adducteur (papillon)",
        duration: '1 min',
        images: [
          'https://images.unsplash.com/photo-1566644942579-6d87ade97537?w=600&q=70',
          'https://images.unsplash.com/photo-1743944701179-487518476c3a?w=600&q=70',
          'https://images.pexels.com/photos/4804303/pexels-photo-4804303.jpeg?auto=compress&cs=tinysrgb&w=600'
        ],
        steps: [
          "Assis au sol, dos droit.",
          "Collez les plantes de pieds l'une contre l'autre.",
          "Laissez les genoux tomber vers l'extérieur.",
          "Attrapez vos pieds avec vos mains.",
          "Penchez-vous doucement vers l'avant en gardant le dos droit.",
          "Poussez doucement les genoux vers le sol avec les coudes."
        ]
      }
    ]
  },
  {
    id: 'mollets',
    label: 'Mollets & Pieds',
    stretches: [
      {
        id: 'mollets_1',
        name: 'Étirement du mollet au mur',
        duration: '30s par jambe',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/99400086a164f94e517e2d7502b866c0ba0bb82a792667788ffb8ce75f833b33.png'
        ],
        steps: [
          "Face au mur, mains posées à hauteur d'épaules.",
          "Reculez le pied droit d'un grand pas, jambe tendue.",
          "Pied avant plié, talon arrière ancré au sol.",
          "Poussez le talon arrière vers le sol.",
          "Sentez l'étirement dans le mollet de la jambe arrière.",
          "Maintenez 30 secondes puis changez de jambe."
        ]
      },
      {
        id: 'mollets_2',
        name: 'Étirement du soléaire',
        duration: '30s par jambe',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/9266e589e332e7968e5213785723d2982f8ab033bfb70da6307b242199237eb2.png'
        ],
        steps: [
          "Même position que l'étirement du mollet au mur.",
          "Cette fois, pliez légèrement le genou arrière.",
          "Gardez le talon au sol.",
          "L'étirement descend plus profondément dans le mollet.",
          "Cible le muscle soléaire (sous le gastrocnémien).",
          "Maintenez 30 secondes puis changez de jambe."
        ]
      },
      {
        id: 'mollets_3',
        name: 'Roulement de la voûte plantaire',
        duration: '1-2 min par pied',
        images: [
          'https://static.prod-images.emergentagent.com/jobs/0f3b0605-7e33-421a-ac22-45a996efdbdf/images/52417f3dbeb4ba546d5dc9535f0740821fb56d71c8a8b47f50da08b69ee6f127.png'
        ],
        steps: [
          "Debout ou assis, placez une balle de tennis sous le pied.",
          "Faites rouler la balle sous la voûte plantaire.",
          "Appuyez plus fort sur les zones tendues.",
          "Roulez du talon vers les orteils.",
          "Insistez sur les points sensibles sans douleur vive.",
          "Alternez entre les deux pieds."
        ]
      }
    ]
  }
];
